var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowSeverity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.29,230.97c-12.01,18.18-7.07,42.65,11.04,54.76l114.71,75.56c8.82-25.19,23-48.16,41.58-67.33l-112.74-74.26c-18.24-11.91-42.68-6.87-54.71,11.29h.13"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.23,222.21c-16.77-10.95-39.41-6.3-50.51,10.37l.07.05c-11.06,16.75-6.49,39.45,10.2,50.61l46.29,30.49c1.61-25.65,10.12-50.3,24.52-71.38l-30.57-20.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.97,180.05v-97.05c-58.11,1.86-113.54,24.82-155.94,64.6l68.59,68.59c24.16-21.63,54.97-34.38,87.35-36.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.68,288.24c-19.21-12.84-24.64-38.79-12.35-58.21.08-.24.19-.47.34-.69,12.9-19.47,39.3-24.91,58.85-12.15l30.77,20.27c2.54-3.41,5.25-6.72,8.11-9.91l-68.69-68.55c-40.45,43.11-63.5,99.68-64.69,158.79h.05c-.06,2.76,2.14,5.04,4.9,5.1h87.1c1.87,0,3.48-1.04,4.34-2.56l-48.73-32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.24,158.95l-68.6,68.6c22.38,24.96,35.25,57.01,36.33,90.51.09,2.69,2.3,4.83,5,4.83h87.1c2.76-.06,4.96-2.34,4.9-5.1-1.19-59.13-24.25-115.72-64.73-158.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.97,308.13c-33.36,0-60.4,27.04-60.4,60.4s27.04,60.4,60.4,60.4,60.4-27.04,60.4-60.4-27.04-60.4-60.4-60.4ZM245.97,333c0-4.42,3.58-8,8-8s8,3.58,8,8v37.79c0,4.42-3.58,8-8,8s-8-3.58-8-8v-37.79ZM253.97,404.18c-4.46,0-8.07-3.61-8.07-8.07s3.61-8.07,8.07-8.07,8.07,3.61,8.07,8.07-3.61,8.07-8.07,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.97,83v97c32.39,1.77,63.2,14.53,87.35,36.18l68.59-68.59c-42.4-39.77-97.84-62.73-155.94-64.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowSeverity);
export default __webpack_public_path__ + "static/media/lowSeverity.42e3782a959c05c9cce68b4e3ab4d8ae.svg";
export { ForwardRef as ReactComponent };